const { CURRENT_FISCAL_YEAR, getFiscalYearList } = require('Util/dateUtil');

module.exports.DATE_FIELDS = {
  date_cleared: 'Date Cleared',
  date_posted: 'Date Entered',
};

const DATE_RANGES = [
  ...getFiscalYearList(5),
  {
    id: 'CM',
    dateRange: [
      new Date(new Date().getFullYear(), new Date().getMonth(), 1),
      new Date(new Date().getFullYear(), new Date().getMonth(), 31),
    ],
    label: 'Current Month',
  },
  {
    id: 'LM',
    dateRange: [
      new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1),
      new Date(new Date().getFullYear(), new Date().getMonth() - 1, 31),
    ],
    label: 'Last Month',
  },
  {
    id: 'CUSTOM',
    dateRange: undefined,
    label: 'Custom',
  },
];

module.exports.DATE_RANGES = DATE_RANGES;

module.exports.LAST_FISCAL_YEAR_DR = DATE_RANGES.find(
  (dr) => dr.id === `FY_${CURRENT_FISCAL_YEAR - 1}`,
);

module.exports.CURRENT_FISCAL_YEAR_DR = DATE_RANGES.find(
  (dr) => dr.id === `FY_${CURRENT_FISCAL_YEAR}`,
);
